import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcprunrequest1postPostRunRequestsResponseSchema = jsonObject
export type tcprunrequest1postPostRunRequestsResponse = z.infer<typeof tcprunrequest1postPostRunRequestsResponseSchema>
export const tcprunrequest1postPostRunRequestsIdApproveResponseSchema = jsonObject
export type tcprunrequest1postPostRunRequestsIdApproveResponse = z.infer<typeof tcprunrequest1postPostRunRequestsIdApproveResponseSchema>
